<template>
  <v-carousel
      style="height: 500px;border-radius: 5px;"
      cycle
      interval="3500"
      hide-delimiters
  >
    <v-carousel-item v-for="i in this.sliderList" :key="i.id">
      <div style="position: relative">
        <v-img style="height: 500px" :src="addBase64Prefix(i.image)" alt="" @click="expandImage(addBase64Prefix(i.image))"/>
        <div class="w-100 text-center py-4 " style="position:absolute;bottom:0;z-index: 9;background: rgb(0,0,0,0.8)">
          <h5 class="text-light" v-if="i.link"><a class="text-light" target="_blank" :href="i.link">{{ i.title }}<v-icon right color="amber">mdi-web</v-icon></a></h5>
          <h5 class="text-light" v-else>{{ i.title }}</h5>
          <p class="text-light">{{ i.text }}</p>
        </div>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import {mapActions} from "vuex";
import {addBase64Prefix} from "@/base64Helper";

export default {
  props: {
      sliderList: {
        type: Array,
        default: null,
      },
  },
  name: "SliderList",
  computed: {
  },
  mounted() {
  },
  methods:{
    addBase64Prefix,
    ...mapActions("slider",["fetchSliderList"]),
    expandImage(images) {
      this.$viewerApi({
        images: [images],
      });
    },
  }
}
</script>

<style scoped>

</style>